import script from "./InsightsView.vue?vue&type=script&setup=true&lang=js"
export * from "./InsightsView.vue?vue&type=script&setup=true&lang=js"

import "./InsightsView.vue?vue&type=style&index=0&id=0199ef4e&scoped=true&lang=css"

import exportComponent from "../../../venturestar-data-emails-sentistar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0199ef4e"]])

export default __exports__